export default __webpack_public_path__ + "54fe67b4e17ebc884702860c875c5a71.jpeg";